/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import userDetail from 'Stores/userDetail';
import { ReactComponent as CompanyLocationIcon } from '../../../../assets/svg/company-location.svg';
import { ReactComponent as ContactLocationIcon } from '../../../../assets/svg/contact-location.svg';

const ContactLocation = props => {
  const {
    contactCity,
    contactState,
    contactCountry,
    companyCountry,
    companyState,
    companyCity,
    showContactLocation,
    showCompanyLocation,
  } = props;

  let contactStr = '';
  if (showContactLocation) {
    if (contactCity) contactStr += contactCity;
    if (contactState)
      if (contactStr !== '') contactStr += `, ${contactState}`;
      else contactStr += contactState;
    if (contactCountry)
      if (contactStr !== '') contactStr += `, ${contactCountry}`;
      else contactStr += contactCountry;
  }

  let companyStr = '';
  if (showCompanyLocation) {
    if (companyCity) companyStr += companyCity;
    if (companyState)
      if (companyStr !== '') companyStr += `, ${companyState}`;
      else companyStr += companyState;
    if (companyCountry)
      if (companyStr !== '') companyStr += `, ${companyCountry}`;
      else companyStr += companyCountry;
  }
  return (
    <div className="contact-location">
      {companyStr && (
        <div className="location-address company-address">
          <div className="info-icon">
            <CompanyLocationIcon />
          </div>
          <div className="info-detail">{companyStr}</div>
        </div>
      )}
      {contactStr && (
        <div
          className={`location-address contact-address ${
            companyStr ? ' pad-top-15' : ''
          }`}
        >
          <div className="info-icon">
            <ContactLocationIcon />
          </div>
          <div className="info-detail">{contactStr}</div>
        </div>
      )}
      {!companyStr && !contactStr && <span>Unavailable</span>}
    </div>
  );
};

export { ContactLocation };
export default ContactLocation;
